module.exports = __webpack_public_path__ + "static/wondagurl-289373215ab6682a53a642206f13211c.jpg";